import React, { Component } from 'react';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom'

import QueueAnim from 'rc-queue-anim';
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
class Category extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grid: props.grid || 1,
            category_id: Number.parseInt(props.match.params.category_id),
            cases: props.cases || [],
            categorys: props.categorys || [],
            relate_cases: [],
            delay: 1500,
        };
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ grid: nextProps.grid,category_id: Number.parseInt(nextProps.match.params.category_id)});
    }
    render() {
        var category_id = this.state.category_id;
        var cases = [];
        this.state.cases.forEach(element => {
            if (element.categoryIds.indexOf(category_id) >= 0) {
                cases.push(element);
            }
        });

        var category = {};
        this.state.categorys.forEach(element => {
            element.children.forEach(children => {
                if (Number.parseInt(children.id) === category_id) {
                    category = children;
                }
            });
        });

        return (
            <QueueAnim type={['right', 'left']} leaveReverse>
                <div className="category-content" key="category-content">
                    <Row gutter={8}>
                        <h1><Texty>{category.name}</Texty></h1>
                        <Col xs={24} sm={24} md={16} lg={18} xl={20}>
                            <QueueAnim type="right" delay={1000}>
                                <p key="key">
                                    {category.description} </p>
                            </QueueAnim>
                        </Col>
                    </Row>
                    <Row gutter={8}>
                        <QueueAnim type="bottom" delay={this.state.delay} leaveReverse>
                            {cases.map(item => (
                                <Col key={item.id} xs={6 * this.state.grid} sm={6 * this.state.grid} md={3 * this.state.grid} lg={3 * this.state.grid} xl={3 * this.state.grid}>
                                    <Link to={"/case/" + item.id}> <img alt={item.name} key={item.id} src={item.thumbnail} style={{ marginTop: 8, width: "100%" }} /></Link>
                                </Col>
                            ))
                            }
                        </QueueAnim>
                    </Row>
                </div>
            </QueueAnim>
        );
    }
}

export default Category;
